import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";

//dialog func - dragable
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function ShoppingList({ shoppingList }) {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Button onClick={handleClickOpen}>
        {shoppingList.length === 0 ? "not found" : "shoppingList "}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          shoppingLists
        </DialogTitle>
        <DialogContent>
          <div className="rtscroll-bg">
            {shoppingList && (
              <div className="rtscroll-div">
                {shoppingList.map((item) => (
                  <div className="rtimage-div" key={item.ts}>
                    <img
                      src={item.imageUrl}
                      alt="/"
                      className="rtscroll-object"
                    />
                    <span className="rtspn">
                      {new Date(item.ts).toLocaleString()}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Exit</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ShoppingList;
